class VwHbsArsivdepoDTO {
    pkArsivdepo: number = null;
    fkRaportiptanim?: number = null;
    depoad?: string = "";
    yerad1?: string = "";
    yersayi1?: number = null;
    yerad2?: string = "";
    yersayi2?: number = null;
    yerad3?: string = "";
    yersayi3?: number = null;
    yerad4?: string = "";
    yersayi4?: number = null;
    yerad5?: string = "";
    yersayi5?: number = null;
    yerad6?: string = "";
    yersayi6?: number = null;
    eklemeTarihi?: string = null;
    ekleyenKullanici?: number = null;
    iptal?: string = "H";
    iptaltarih?: string = null;
    fkIptalkullanici?: number = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    fkIptalneden?: number = null;
}
export default VwHbsArsivdepoDTO;